/**
 * Created by Daniela on 19/10/2016.
 */
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { editRoute, newRoute } from '../../shared/services/data.service';
import { SeguradoraFormComponent } from "./seguradora-form/seguradora-form.component";
import { SeguradoraListComponent } from "./seguradora-list/seguradora-list.component";

@NgModule({
  imports: [
    RouterModule.forChild([])
  ],
  exports: [
    RouterModule
  ]
})
export class SeguradorasRoutingModule {}

export const seguradorasRoutes: any[] = [
  {
    path: '',
    component: SeguradoraListComponent
  },{
    path: editRoute + '/:id',
    component: SeguradoraFormComponent
  },{
    path: newRoute,
    component: SeguradoraFormComponent
  }
];



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/despachos/seguradoras/seguradoras-routing.module.ts
 **/